import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';
import { StyledOfferBoardCard } from '../../molecules/offer-board-card/offer-board-card.style';
import { StyledHeader } from '../../../components/atoms/section-headline/section-headline.style';

export const StyledOuterWrapper = styled.section`
    background-color: ${(props) => props.theme.shades.white};
`;

export const StyledHeaderWrapper = styled.div`
    ${StyledHeader} {
        @media ${mediaQueries.tabletAndUp} {
            padding-top: 30px;
            padding-bottom: 0;
            background-color: transparent;
        }
    }
`;

export const StyledTeaserWrapper = styled.div`
    padding-bottom: 30px;
    @media ${mediaQueries.tabletAndUp} {
        padding-top: 30px;
    }
`;

export const StyledCardsWrapper = styled.div`
    margin: auto;
    max-width: calc(100% - 20px);

    @media ${mediaQueries.tablet} {
        margin: 0 auto;
        max-width: calc(100% - 30px);
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        max-width: 1184px;
    }

    @media ${mediaQueries.smallDesktop} and (orientation: landscape) {
        margin: 0 auto;
        padding-left: ${(props) => props.theme.spacing.large};
        padding-right: ${(props) => props.theme.spacing.large};
    }
`;

export const StyledCardsComponent = styled.div<{ count: number }>`
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 20px 0 10px 0;
    margin: 0 auto;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;

    @media ${mediaQueries.smallDesktopAndUp} {
        justify-content: ${(props) => (props.count < 3 ? `center` : `flex-start`)};
        flex-wrap: wrap;
        overflow-x: none;
    }

    @media ${mediaQueries.tablet} {
        ${StyledOfferBoardCard} {
            min-width: 42%;
        }
    }
    @media ${mediaQueries.phone} {
        ${StyledOfferBoardCard} {
            min-width: 85%;
        }
    }
`;

export const StyledButtonWrapper = styled.div`
    text-align: center;
    && div button span:first-child {
        padding-left: 12px !important;
    }
`;
